// src/lib/ipRankerHelper.js
import IPRanker from "@ipranker/sdk";

const IPRANKER_KEY = "kmWh3MyptFBCHggy2T9KMFCaRHf8a-OehMdr6CHegYI";

let ipRankerInstance = null;

export const getIPRankerInstance = () => {
  if (!ipRankerInstance) {
    ipRankerInstance = new IPRanker(IPRANKER_KEY, {baseURL: "https://apiv1.ipranker.com"});
  }
  return ipRankerInstance;
};
